import { h, Component } from 'preact';

export default class RadioGroup extends Component {
  render({ label, inputName, isChecked, onChange }, {}) {
    return (
      <div onClick={e => onChange(e)} className={`theme-card pos-r`}>
        <div className="theme-strip">
          <label className="lbl">
            {label}
            <input type="radio" name={inputName} checked={isChecked} />
            <span className="checkmark" />
          </label>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./checkout/components/radio/index.js